/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ProblemResponse {
  /**
   * A short, human-readable summary of the problem type.
   * @maxLength 200
   * @example "Incorrect credentials"
   */
  title: string;
  /**
   * The HTTP status code.
   * @format int32
   * @example 403
   */
  status: number;
  /**
   * A human-readable explanation specific to this occurrence of the problem.
   * @maxLength 1000
   * @example "Incorrect password"
   */
  detail: string;
  /**
   * A URI reference that indicates the specific occurrence of the problem. It points to the path of the HTTP request that resulted in the error or problem state.
   * @format uri
   * @example "/auth/login"
   */
  instance: string;
  /**
   * A authentication challenge.
   * @pattern ^[A-Z]+(_[A-Z]+)*$
   */
  challenge?: string;
  /**
   * A URL to documentation
   * @format uri
   * @example "about:blank"
   */
  type?: string;
  /**
   * A UUID that uniquely identifies the request leading to this error response, facilitating tracing and debugging.
   * @format uuid
   */
  requestId: string;
}

export interface SyndicatesConfiguration {
  syndicate_id?: string;
  /** Details of each configuration item. This could include URLs, IDs, secrets, etc. */
  syndicate_configuration?: {
    /**
     * Base URL for the syndicate service.
     * @example "https://example.com"
     */
    syndicate_url: string;
    /**
     * ID of the user pool in use.
     * @example "pool123"
     */
    user_pool_id: string;
    /**
     * Client ID for the service.
     * @example "client123"
     */
    client_id: string;
    /**
     * Secret key associated with the client ID.
     * @example "secretXYZ"
     */
    client_secret: string;
    /**
     * Secret key used for impersonating users.
     * @example "impersonate123"
     */
    impersonation_secret: string;
    /**
     * List of identity providers enabled for authentication.
     * @example ["COGNITO","OKTA"]
     */
    identity_providers: string[];
    /** Configuration details for the JWK client. */
    jwk_client: {
      /** The issuer URL for the JWT provider. */
      issuer: string;
      /** URL to the JSON Web Key Set (JWKS). */
      jwks_uri: string;
      /** Time in seconds for which the JWKS are cached. */
      lifespan_seconds: number;
      /** List of supported JWT signing algorithms. */
      supported_signing_algorithms: string[];
    };
    /** Domain used for SAML authentication, if applicable. */
    saml_auth_domain: string | null;
    /** Client identifier for SAML services, if applicable. */
    saml_client_id: string | null;
    /** Secret associated with the SAML client ID, if applicable. */
    saml_client_secret: string | null;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Kubit Authentication API
 * @version 0.0.1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * No description
     *
     * @tags External, Credentials Login
     * @name RoutesAuthLoginLogin
     * @summary Login endpoint
     * @request POST:/auth/login
     */
    routesAuthLoginLogin: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /**
         * @format password
         * @maxLength 256
         * @pattern [\S]+
         */
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, Credentials Login, SAML Login
     * @name RoutesAuthTokenLogoutLogout
     * @summary Logout Endpoint
     * @request POST:/auth/token/logout
     */
    routesAuthTokenLogoutLogout: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/token/logout`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, Credentials Login, SAML Login
     * @name RoutesAuthTokenRefreshRefreshIdToken
     * @summary Refresh ID tokens
     * @request POST:/auth/token/refresh
     */
    routesAuthTokenRefreshRefreshIdToken: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/token/refresh`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, Credentials Login
     * @name RoutesAuthPasswordChangePassword
     * @summary Change password
     * @request POST:/auth/password
     */
    routesAuthPasswordChangePassword: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /**
         * @format password
         * @maxLength 256
         * @pattern [\S]+
         */
        oldPassword: string;
        /**
         * @format password
         * @maxLength 256
         * @pattern [\S]+
         */
        newPassword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, MFA
     * @name RoutesAuthMfaConfigureConfigure
     * @summary Configure MFA
     * @request POST:/auth/mfa/configure
     */
    routesAuthMfaConfigureConfigure: (params: RequestParams = {}) =>
      this.request<
        {
          /** The secret code required for configuring MFA. */
          secretCode?: string;
        },
        ProblemResponse
      >({
        path: `/auth/mfa/configure`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, MFA
     * @name RoutesAuthMfaConfirmConfirm
     * @summary Confirm MFA token
     * @request POST:/auth/mfa/confirm
     */
    routesAuthMfaConfirmConfirm: (
      data: {
        /**
         * The MFA code provided by the user.
         * @pattern ^\d{6}$
         */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/mfa/confirm`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, MFA
     * @name RoutesAuthMfaVerifyVerify
     * @summary Verify MFA token
     * @request POST:/auth/mfa/verify
     */
    routesAuthMfaVerifyVerify: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /** @pattern ^\d{6}$ */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/mfa/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, Password Recovery
     * @name RoutesAuthRecoveryForgotPasswordForgotPassword
     * @summary Forgot password endpoint
     * @request POST:/auth/recovery/forgot-password
     */
    routesAuthRecoveryForgotPasswordForgotPassword: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /**
         * The email address or phone number destination where the code is sent.
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        destination?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/recovery/forgot-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, Password Recovery
     * @name RoutesAuthRecoveryConfirmPasswordConfirmPassword
     * @summary Confirm forgot password endpoint
     * @request POST:/auth/recovery/confirm-forgot-password
     */
    routesAuthRecoveryConfirmPasswordConfirmPassword: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /**
         * @format password
         * @minLength 1
         * @maxLength 2048
         * @pattern [\S]+
         */
        confirmationCode: string;
        /**
         * @format password
         * @maxLength 256
         * @pattern [\S]+
         */
        newPassword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
        },
        ProblemResponse
      >({
        path: `/auth/recovery/confirm-forgot-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a JSON object containing the Amazon Cognito User Pool ID and Client ID among other configuration settings.
     *
     * @tags External
     * @name RoutesAuthConfigGetConfiguration
     * @summary Retrieves configuration for the frontend.
     * @request GET:/auth/config
     */
    routesAuthConfigGetConfiguration: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "success" */
          status: string;
          /** @example "us-east-1_example" */
          userPoolId: string;
          /** @example "2abcd3example" */
          clientId: string;
          /** @example true */
          isSSOEnabled: boolean;
          /** @example true */
          isMigration: boolean;
        },
        ProblemResponse
      >({
        path: `/auth/config`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, SAML Login
     * @name RoutesAuthSamlCallbackCallback
     * @summary SAML callback endpoint
     * @request GET:/auth/saml/callback
     */
    routesAuthSamlCallbackCallback: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/auth/saml/callback`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External, SAML Login
     * @name RoutesAuthSamlLoginLoginSaml
     * @summary SAML login endpoint
     * @request GET:/auth/saml/login
     */
    routesAuthSamlLoginLoginSaml: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/auth/saml/login`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Provides a file download for the Kubit logo in PNG format. The file is served as an attachment to prompt a download dialogue on the client side.
     *
     * @tags External
     * @name RoutesAuthLogoGetLogo
     * @summary Download Kubit logo for use with customer SAML applications
     * @request GET:/auth/logo
     */
    routesAuthLogoGetLogo: (params: RequestParams = {}) =>
      this.request<File, ProblemResponse>({
        path: `/auth/logo`,
        method: 'GET',
        ...params,
      }),
  };
  authInternal = {
    /**
     * No description
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserTokenGetToken
     * @summary Obtain a token for a user by email
     * @request GET:/auth-internal/user/token
     */
    routesInternalUserTokenGetToken: (
      query: {
        /**
         * The user's email to obtain the token for.
         * @format email
         */
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** The ID token of the user. */
          idToken: string;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user/token`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserCreateCreateUser
     * @summary Create a new user
     * @request POST:/auth-internal/user
     */
    routesInternalUserCreateCreateUser: (
      data: {
        /**
         * @format email
         * @minLength 1
         * @maxLength 128
         */
        username: string;
        /**
         * @minLength 0
         * @maxLength 128
         */
        firstName?: string;
        /**
         * @minLength 0
         * @maxLength 128
         */
        familyName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /** @example "FORCE_CHANGE_PASSWORD" */
          userStatus?: string;
          /**
           * The date and time when the user was created.
           * @format date-time
           * @example "2023-07-08T12:34:56Z"
           */
          creationDate?: string;
          /**
           * The date and time when the user's was invited in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteDate?: string | null;
          /**
           * The date and time when the user's invite expires in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteExpirationDate?: string | null;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserDeleteDeleteUser
     * @summary Delete a user by username
     * @request DELETE:/auth-internal/user
     */
    routesInternalUserDeleteDeleteUser: (
      data: {
        /**
         * The email of the user to be deleted.
         * @format email
         * @example "user@example.com"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /** @example "User has been deleted successfully." */
          message?: string;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the creation date, user status, and invite expiration date (if applicable) for a specified user.
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserStatusGetStatus
     * @summary Retrieve user status
     * @request GET:/auth-internal/user/status
     */
    routesInternalUserStatusGetStatus: (
      query: {
        /**
         * The email of the user whose status is being retrieved.
         * @format email
         * @example "user@example.com"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /**
           * The date and time when the user was created.
           * @format date-time
           * @example "2023-07-08T12:34:56Z"
           */
          creationDate?: string;
          /**
           * The status of the user.
           * @example "CONFIRMED"
           */
          userStatus?: string;
          /**
           * Indicates that the status is enabled.
           * @example true
           */
          enabled?: boolean;
          /**
           * The date and time when the user's was invited in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteDate?: string | null;
          /**
           * The date and time when the user's invite expires in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteExpireDate?: string | null;
          /**
           * Indicates whether the invite is active.
           * @example true
           */
          inviteActive?: boolean | null;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user/status`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resends an invite to the specified user.
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserInviteResendInvite
     * @summary Resend invite to user
     * @request POST:/auth-internal/user/resend-invite
     */
    routesInternalUserInviteResendInvite: (
      data: {
        /**
         * The email of the user to resend the invite to.
         * @format email
         * @example "user@example.com"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /** @example "FORCE_CHANGE_PASSWORD" */
          userStatus?: string;
          /**
           * The date and time when the user's was invited in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteDate?: string | null;
          /**
           * The date and time when the user's invite expires in UTC.
           * @format date-time
           * @example "2024-01-01T15:00:00Z"
           */
          inviteExpireDate?: string | null;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user/resend-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserDisableDisableUser
     * @summary Disable a user by username
     * @request POST:/auth-internal/user/disable
     */
    routesInternalUserDisableDisableUser: (
      data: {
        /**
         * The email of the user to be disabled.
         * @format email
         * @example "user@example.com"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /** @example "User has been disabled successfully." */
          message?: string;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user/disable`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal, User Management
     * @name RoutesInternalUserEnableEnableUser
     * @summary Enable a user by username
     * @request POST:/auth-internal/user/enable
     */
    routesInternalUserEnableEnableUser: (
      data: {
        /**
         * The email of the user to be enabled.
         * @format email
         * @example "user@example.com"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "success" */
          status?: string;
          /** @example "User has been enabled successfully." */
          message?: string;
        },
        ProblemResponse
      >({
        path: `/auth-internal/user/enable`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns current configuration as JSON.
     *
     * @tags Internal, Configuration
     * @name RoutesInternalConfigurationGetGet
     * @summary Get current configuration
     * @request GET:/auth-internal/configuration
     */
    routesInternalConfigurationGetGet: (params: RequestParams = {}) =>
      this.request<Record<string, SyndicatesConfiguration>, ProblemResponse>({
        path: `/auth-internal/configuration`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Reload configuration settings from the secret manager and returns them as JSON.
     *
     * @tags Internal, Configuration
     * @name RoutesInternalConfigurationReloadReload
     * @summary Reload existing configuration
     * @request POST:/auth-internal/configuration/reload
     */
    routesInternalConfigurationReloadReload: (params: RequestParams = {}) =>
      this.request<
        {
          /**
           * Indicates the result of the configuration reload operation.
           * @example "success"
           */
          status: string;
          /** A dictionary where each key is a syndicate identifier and the value is the configuration details for that syndicate. */
          configuration: Record<string, SyndicatesConfiguration>;
        },
        ProblemResponse
      >({
        path: `/auth-internal/configuration/reload`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the health status of AWS Cognito and Secrets Manager.
     *
     * @tags Internal
     * @name RoutesInternalHealthHealthGetSystemHealth
     * @summary Checks the health of the system
     * @request GET:/auth-internal/health
     */
    routesInternalHealthHealthGetSystemHealth: (params: RequestParams = {}) =>
      this.request<
        {
          /**
           * Overall health status of the system
           * @example "healthy"
           */
          status?: string;
          /**
           * Health status of AWS Cognito
           * @example "ok"
           */
          cognito?: string;
        },
        ProblemResponse
      >({
        path: `/auth-internal/health`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
